/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { useCallback, useState } from 'fierry/react';

import Section from 'solis/claude/primitive/section';
import Text from 'solis/react/primitive/text';

import ZoneEvent from 'solis/claude/element/zone/event';
import EventMore from 'solis/claude/element/zone/event.more';


const LIMIT = 3;


const getEvents = ({ zoneTimeline, currentDate, previousDate }, expanded) =>
{
  const events = zoneTimeline.getFutureEvents(previousDate ?? currentDate);

  const visibleEvents = expanded ? events : events.slice(0, LIMIT);

  return { events: visibleEvents, hiddenCount: events.length - visibleEvents.length };
};


const OnExpand = (event, setExpanded) =>
{
  setExpanded(true);
};


const EventRows = ({ events, ...props }) =>
{
  return events.map((event, index) =>
  (
    <ZoneEvent key = {index} {...props} event = {event} index = {index} />
  ));
};


const Component = ({ hiddenCount, onExpand, ...props }) =>
(
  <Section>

    <Text.Label>Next</Text.Label>

    <EventRows {...props} />
    <EventMore count = {hiddenCount} onExpand = {onExpand} />

  </Section>
);


export default (props) =>
{
  const [ expanded, setExpanded ] = useState(false);

  const onExpand = useCallback(OnExpand, [ setExpanded ]);

  const { events, hiddenCount } = getEvents(props, expanded);

  return events.length ? <Component {...props} events = {events} hiddenCount = {hiddenCount} onExpand = {onExpand} /> : null;
};
